module.exports = __webpack_public_path__ + "img/us-full.ea00c326.svg";